var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M480 64H32C14.4 64 0 78.4 0 96v320c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32V96c0-17.6-14.4-32-32-32zm-32 64v23L256 264.143 64 151v-23h384zM64 384V206.714l192 113.143 192-113.143V384H64z"}));
}

Mail.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Mail;

Mail.default = Mail;
